/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ week: NonNullable<unknown> }} Plan_Suggestion_Isolation_OnsetInputs */

const en_us2_plan_suggestion_isolation_onset = /** @type {(inputs: Plan_Suggestion_Isolation_OnsetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.week} weeks in. Time to add isolation work. Review the updated plan.`)
};

const pt_br2_plan_suggestion_isolation_onset = /** @type {(inputs: Plan_Suggestion_Isolation_OnsetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.week} semanas de treino. Hora de incluir exercícios isolados. Revise o plano atualizado.`)
};

const es_419_plan_suggestion_isolation_onset = /** @type {(inputs: Plan_Suggestion_Isolation_OnsetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.week} semanas de entrenamiento. Es hora de sumar ejercicios de aislamiento. Revisa el plan actualizado.`)
};

const pt_pt2_plan_suggestion_isolation_onset = /** @type {(inputs: Plan_Suggestion_Isolation_OnsetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.week} semanas de treino. Está na hora de incluir exercícios de isolamento. Revê o plano atualizado.`)
};

const fr_fr2_plan_suggestion_isolation_onset = /** @type {(inputs: Plan_Suggestion_Isolation_OnsetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.week} semaines déjà. Place à l'isolation. Revois le programme mis à jour.`)
};

const de_de2_plan_suggestion_isolation_onset = /** @type {(inputs: Plan_Suggestion_Isolation_OnsetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.week} Wochen Training. Zeit für Isolationsübungen. Prüf den aktualisierten Plan.`)
};

const it_it2_plan_suggestion_isolation_onset = /** @type {(inputs: Plan_Suggestion_Isolation_OnsetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.week} settimane di allenamento. È ora di aggiungere esercizi di isolamento. Rivedi la scheda aggiornata.`)
};

/**
* | output |
* | --- |
* | "{week} weeks in. Time to add isolation work. Review the updated plan." |
*
* @param {Plan_Suggestion_Isolation_OnsetInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_suggestion_isolation_onset = /** @type {((inputs: Plan_Suggestion_Isolation_OnsetInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Suggestion_Isolation_OnsetInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_suggestion_isolation_onset(inputs)
	if (locale === "es-419") return es_419_plan_suggestion_isolation_onset(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_suggestion_isolation_onset(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_suggestion_isolation_onset(inputs)
	if (locale === "de-DE") return de_de2_plan_suggestion_isolation_onset(inputs)
	if (locale === "it-IT") return it_it2_plan_suggestion_isolation_onset(inputs)
	return en_us2_plan_suggestion_isolation_onset(inputs)
});
export { plan_suggestion_isolation_onset as "plan.suggestion.isolation_onset" }